<template>
<div style="display: inline" class="m-10">
  <el-badge class="mark" :value="pending.length">
    <el-button type="default" size="small" icon="el-icon-view" 
      @click="openListPending()" >
        Pendientes
    </el-button>
  </el-badge>
  <el-dialog title="Ajustes pendientes" :visible.sync="showDialogPending" width="30%" >
    <el-table :data="pending" empty-text="No hay ajustes pendientes" width="100%" >
      <el-empty slot="empty" description="No hay datos"></el-empty>
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column property="fecha" label="Fecha" width="130"></el-table-column>
      <el-table-column property="observacion" label="Observación" ></el-table-column>
      <el-table-column
        prop="actioions"
        label="Acciones"
        width="100">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="selectRow(pending[scope.$index])"
            type="primary"
            size="small" icon="el-icon-check">Usar
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data(){
    return {
      showDialogPending: false,
    }
  },
  created() {
    this.getPending();
  },
  computed:{
    ...mapGetters(['pending'])
  },
  methods: {
    ...mapActions([
      'inputAndOutputAdjust/selectAdjustPendingAction',
      'inputAndOutputAdjust/getPendingAction',
    ]),
    selectRow(auditory) {
      this.showDialogPending = false;
      this['inputAndOutputAdjust/selectAdjustPendingAction']({ auditoryId: auditory.id })
    },
    openListPending() {
      this.showDialogPending = true;
    },
    getPending() {
      this['inputAndOutputAdjust/getPendingAction'](this.$route.meta.typeDocument)
    },
  },
}
</script>